import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FooterModule, HeaderModule, ModalSelecaoTipoEnvioLinkModule } from '@usucampeao/ui-mobile';
import { ContratoTipoAssinaturaModule } from '@usucampeao/utils-frontend';
import { ComprovanteRendaSelecionarTipoAssinaturaPageRoutingModule } from './comprovante-renda-selecionar-tipo-assinatura-routing.module';
import { ComprovanteRendaSelecionarTipoAssinaturaPage } from './comprovante-renda-selecionar-tipo-assinatura.page';

@NgModule({
  imports: [
    // root modules
    CommonModule,
    IonicModule,

    // route
    ComprovanteRendaSelecionarTipoAssinaturaPageRoutingModule,

    // components modules
    ContratoTipoAssinaturaModule,
    FooterModule,
    HeaderModule,
    ModalSelecaoTipoEnvioLinkModule,
  ],
  providers: [],
  declarations: [ComprovanteRendaSelecionarTipoAssinaturaPage],
})
export class ComprovanteRendaSelecionarTipoAssinaturaPageModule { }
